import { render, staticRenderFns } from "./UnitInformationAligned.vue?vue&type=template&id=59aefa3f&scoped=true&lang=pug&"
import script from "./UnitInformationAligned.vue?vue&type=script&lang=ts&"
export * from "./UnitInformationAligned.vue?vue&type=script&lang=ts&"
import style0 from "./UnitInformationAligned.vue?vue&type=style&index=0&id=59aefa3f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59aefa3f",
  null
  
)

export default component.exports